import { Event } from 'stream-chat'
import { ChatService } from '@/services/Chat/ChatService'
import { ChannelOptions } from '../types'

export function shouldIncrementUnread(
  event: Event,
  currentUserId: string,
  activeChannelId: string | null,
  isViewingMessages: boolean
): boolean {
  // Hidden system messages must not affect unread counts or sounds
  if (ChatService.isSystemMessage(event.message)) return false
  const messageUserId = event.message?.user?.id
  // Don't increment for own messages
  if (messageUserId === currentUserId) return false
  // Don't increment if viewing the channel the message came from
  if (isViewingMessages && event.channel_id === activeChannelId) return false
  return true
}

export function getChannelTypeFromEvent(event: Event): ChannelOptions | null {
  const channelType = event.channel?.channel_type
  if (channelType === ChannelOptions.DirectMessages) {
    return ChannelOptions.DirectMessages
  }
  if (channelType === ChannelOptions.CaseMessages) {
    return ChannelOptions.CaseMessages
  }
  return null
}

export function playNotificationSound(): void {
  try {
    const audio = new Audio('/new-message.mp3')
    audio.play()
  } catch {
    // Silently fail - audio playback is non-critical
  }
}
